/**
 * L'icona di ogni evento delle statistiche, per Trend (V62) e Confronto (V31).
 */

import type { ReactNode } from 'react';
import { ArrowRightLeftIcon, ClockIcon, CrosshairIcon } from 'lucide-react';
import { IconaEvento } from '../partite/eventi.js';
import type { Evento } from './trend.js';

const NEUTRA = 'size-4 shrink-0 text-evento-neutro';

/**
 * L'icona di ogni evento, la stessa del Live Timer; tiri e passaggi in totale
 * e minuti non sono un evento solo e hanno un'icona neutra.
 */
export const ICONA_EVENTO: Record<Evento, ReactNode> = {
  gol: <IconaEvento tipo="gol" />,
  assist: <IconaEvento tipo="assist" />,
  tiri: <CrosshairIcon aria-hidden className={NEUTRA} />,
  tiriSpecchio: <IconaEvento tipo="tiro_specchio" />,
  tiriFuori: <IconaEvento tipo="tiro_fuori" />,
  passaggi: <ArrowRightLeftIcon aria-hidden className={NEUTRA} />,
  passaggiCompletati: <IconaEvento tipo="passaggio_completato" />,
  passaggiSbagliati: <IconaEvento tipo="passaggio_sbagliato" />,
  palleConquistate: <IconaEvento tipo="palla_conquistata" />,
  pallePerse: <IconaEvento tipo="palla_persa" />,
  autogol: <IconaEvento tipo="autogol" />,
  gialli: <IconaEvento tipo="cartellino_giallo" />,
  rossi: <IconaEvento tipo="cartellino_rosso" />,
  minuti: <ClockIcon aria-hidden className={NEUTRA} />,
};
